import Auth from '@aws-amplify/auth';
import { API } from 'aws-amplify';
import Axios from 'axios';
import { uniqueId } from 'lodash-es';
import Sockette from 'sockette';
import {
  GET_AIRCRAFT_FAILURE,
  GET_AIRCRAFT_REQUEST,
  GET_AIRCRAFT_SUCCESS,
  SUBSCRIBE_TO_TELEMETRY_PENDING,
  SOCKET_OPEN,
  UPDATE_LIVE_AIRCRAFT_DATA,
  SOCKET_RECONNECT,
  SOCKET_CLOSED,
  SOCKET_ERROR,
  SUBSCRIBE_TO_TELEMETRY_FAILED,
  TELEMETRY_SUBSCRIBED,
  TOGGLE_GEOTUNNEL,
  HIGHLIGHT_CRAFT,
  TOGGLE_SHOW_SITL,
  CHOOSE_LOCATION,
  CHOOSE_AIRCRAFT,
  MESSAGING_PENDING,
  MESSAGING_FAILED,
  GROUND_TEAM_DATA,
  GET_LANDING_PADS_SUCCESS,
  GET_LANDING_PADS_FAILURE,
  LINK_PAD_WITH_CHANNEL,
  UPDATE_LANDING_PAD_PENDING,
  UPDATE_LANDING_PAD_SUCCESS,
  UPDATE_LANDING_PAD_FAILURE,
  LINK_PAD_WITH_AIRCRAFT_PENDING,
  LINK_PAD_WITH_AIRCRAFT_SUCCESS,
  LINK_PAD_WITH_AIRCRAFT_FAILURE,
  REMOVE_AIRCRAFT_FROM_PAD_SUCCESS,
  REMOVE_AIRCRAFT_FROM_PAD_PENDING,
  REMOVE_AIRCRAFT_FROM_PAD_FAILURE
} from './actionTypes';
import { telemetryDetails } from '../data/uavConnectionDetails';
import { updateClients } from './orderActions';
import { LandingPad } from '@m4a3/api-client';

export const getAircraft = () => async dispatch => {
  dispatch({ type: GET_AIRCRAFT_REQUEST });
  try {
    const res = await Axios.get(
      'https://dhh5va9wrj.execute-api.eu-west-1.amazonaws.com/dev/index'
    );

    dispatch({ type: GET_AIRCRAFT_SUCCESS, payload: res.data });

    return res.data;
  } catch (err) {
    dispatch({ type: GET_AIRCRAFT_FAILURE });
  }
};

const RELAY_URL = process.env.REACT_APP_RELAY_URL;

export const subscribeToLiveAircraft = () => dispatch => {
  dispatch(subscribeToAicraftTelemetry('&live=true'));
};
export const subscribeToSpecificAircraft = (ids = []) => async dispatch => {
  if (ids.length === 0) return;
  const telemetryUrlParams = ids
    .filter(id => !!telemetryDetails?.[id])
    .map(id => {
      return `&telemetryUrl=${telemetryDetails?.[id]}`;
    })
    .join('');
  dispatch(subscribeToAicraftTelemetry(telemetryUrlParams));
};
let sockette;

export const subscribeToAicraftTelemetry = params => async dispatch => {
  dispatch({ type: SUBSCRIBE_TO_TELEMETRY_PENDING });

  try {
    let interval;
    const authSession = await Auth.currentSession();
    // @ts-ignore - Access token exists on the AuthSession 🚨 be aware of this type error 🚨
    const token = authSession.accessToken.jwtToken;
    const telemetryUrl = `${RELAY_URL}?authorization=${token}`;
    if (sockette) {
      return;
    }
    sockette = new Sockette(telemetryUrl + params, {
      timeout: 5e3,
      maxAttempts: 10,
      onopen: evt => {
        dispatch({ type: SOCKET_OPEN });
        setInterval(() => {
          // @ts-ignore - readyState exists on the EventTarget 🚨 be aware of this type error 🚨
          if (sockette && evt.target.readyState === 0) {
            sockette.send(`{"action":"PING","id":"${uniqueId()}"}`);
          }
        }, 1000);
        // @ts-ignore - readyState exists on the EventTarget 🚨 be aware of this type error 🚨
        if (sockette && evt.target.readyState === 0) {
          sockette.send('{"action":"SUBSCRIBE_TELEMETRY"}');
        }
      },
      onmessage: message => {
        if (message?.data === 'TELEMETRY SUBSCRIBED') {
          dispatch({ type: TELEMETRY_SUBSCRIBED, payload: message });
        } else {
          dispatch(consumeAircraftMessage(message?.data));
        }
      },
      onreconnect: () => {
        dispatch({ type: SOCKET_RECONNECT });
      },
      onclose: e => {
        clearInterval(interval);
        sockette = null; // Clear sockette so reconnection can work
        dispatch({ type: SOCKET_CLOSED, payload: e });
      },
      onerror: err => {
        sockette = null; // Clear sockette on error so reconnection can work
        dispatch({ type: SOCKET_ERROR, payload: err });
      }
    });
  } catch (err) {
    sockette = null; // Clear sockette on exception
    dispatch({ type: SUBSCRIBE_TO_TELEMETRY_FAILED, payload: err });
  }
};

let messagingSocket;

export const subscribeToMessaging = () => async dispatch => {
  try {
    const telemetryUrl = `${process.env.REACT_APP_MESSAGING_URL}?client=OrderHub`;

    messagingSocket = new Sockette(telemetryUrl, {
      onmessage: message => {
        dispatch(consumeMannaMessage(message?.data));
      }
    });
  } catch (err) {
    dispatch({ type: MESSAGING_FAILED, payload: err });
  }
};

export const updateTeam = (id, team) => {
  if (messagingSocket) {
    messagingSocket.send(
      JSON.stringify({
        type: 'updateTeam',
        data: {
          id,
          team
        }
      })
    );
  }
};

const consumeAircraftMessage = message => dispatch => {
  try {
    const data = JSON.parse(message);

    const colourOrder = ['black', 'blue', 'yellow', 'red'];
    Object.keys(data || {}).forEach((key, i) => {
      data[key] = { ...data[key], colour: colourOrder[i % 4] };
    });
    dispatch({
      type: UPDATE_LIVE_AIRCRAFT_DATA,
      payload: data
    });
  } catch (err) {}
};
const consumeMannaMessage = message => dispatch => {
  try {
    const data = JSON.parse(message);

    if (data?.type === 'updatePositions') {
      dispatch({
        type: GROUND_TEAM_DATA,
        payload: data
      });
    } else if (data?.type === 'updateClients') {
      dispatch(updateClients(data?.data));
    } else if (data?.type === 'updateOrders') {
      // dispatch({
      //   type: ORDERS_RECEIVED,
      //   payload: { createdOrders: [], ordersToFilter: data?.data }
      // });
    }
  } catch (err) {}
};

export const toggleGeotunnel = () => ({ type: TOGGLE_GEOTUNNEL });
export const toggleShowSitl = () => ({ type: TOGGLE_SHOW_SITL });
export const chooseLocation = location => ({
  type: CHOOSE_LOCATION,
  payload: location
});
export const chooseAircraft = location => ({
  type: CHOOSE_AIRCRAFT,
  payload: location
});

export const getLandingPadsSuccess = res => ({
  type: GET_LANDING_PADS_SUCCESS,
  payload: res
});
export const getLandingPadsFailure = () => ({ type: GET_LANDING_PADS_FAILURE });

export const getLandingPads = () => async dispatch => {
  try {

    const res: LandingPad[] = await API.get('api', `/addressfind/listLandingPads?includeInactivePads=true`, undefined);

    dispatch(getLandingPadsSuccess(res));
  } catch (err) {
    dispatch(getLandingPadsFailure());
  }
};
export const updateLandingPadPending = () => ({ type: UPDATE_LANDING_PAD_PENDING });
export const updateLandingPadSuccess = res => ({
  type: UPDATE_LANDING_PAD_SUCCESS,
  payload: res
});
export const updateLandingPadFailure = () => ({ type: UPDATE_LANDING_PAD_FAILURE });


export const updateLandingPadActive = (landingPadId: number, active: boolean) => async dispatch => {
  try {
    dispatch(updateLandingPadPending());
    const res = await API.put('api', `/addressfind/landingPad/${landingPadId}/active?active=${active}`, {});

    dispatch(updateLandingPadSuccess(res));
  } catch (err) {
    dispatch(updateLandingPadFailure());
  }
};
export const linkPadWithAircraftPending = () => ({ type: LINK_PAD_WITH_AIRCRAFT_PENDING });
export const linkPadWithAircraftSuccess = res => {
  return {
    type: LINK_PAD_WITH_AIRCRAFT_SUCCESS,
    payload: res
  }
};
export const linkPadWithAircraftFailure = () => ({ type: LINK_PAD_WITH_AIRCRAFT_FAILURE });
export const linkPadWithAircraft = (pad, aircraft) => async dispatch => {
  try {

    dispatch(linkPadWithAircraftPending());
    await API.post('api', `/mission/landingPad/assignAircraft/${pad}/${aircraft}`, {body: {}});

    dispatch(linkPadWithAircraftSuccess({pad, aircraft}));
  } catch (err) {
    dispatch(linkPadWithAircraftFailure());
  }
};

export const removeAircraftFromPadPending = () => ({ type: REMOVE_AIRCRAFT_FROM_PAD_PENDING });
export const removeAircraftFromPadSuccess = res => {
  return {
    type: REMOVE_AIRCRAFT_FROM_PAD_SUCCESS,
    payload: res
  }
};
export const removeAircraftFromPadFailure = () => ({ type: REMOVE_AIRCRAFT_FROM_PAD_FAILURE });
export const removeAircraftFromPad = (pad, aircraft) => async dispatch => {
  try {
    dispatch(removeAircraftFromPadPending());
    await API.post('api', `/mission/landingPad/removeAircraft/${pad}/${aircraft}`, {body: {}});
    dispatch(removeAircraftFromPadSuccess({pad, aircraft}));
  } catch (err) {
    dispatch(removeAircraftFromPadFailure());
  }
};

export const linkPadWithChannel = (pad, channel) => {
  return {
    type: LINK_PAD_WITH_CHANNEL,
    payload: { pad, channel }
  };
};
